<template>
  <div id="app">
    <div style="margin:0 auto;text-align:left;">
      <router-view />
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';
export default {
  name: "App",
  data(){
    return {
      windowWidth: window.innerWidth,
      resizeHandler: null, // 保存防抖函数引用
      queryParams: {
        lang: 'zh'
      }
    }
  },
  created(){
  },
  mounted() {
    document.title = "XRION"
    if (!localStorage.getItem("lang")) {
      this.setLanguage();
    }
    // 创建防抖函数（延迟 300ms，仅尾部触发）
    this.resizeHandler = debounce(() => {
      this.windowWidth = window.innerWidth;
      console.log("this.windowWidth111",this.windowWidth);
      if(this.$route?.path !== '/StripePay'){
        location.reload()
      }
    }, 300);
    
    // 绑定窗口大小变化事件
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    localStorage.clear()
    // &#9888;️ 重要：移除事件监听防止内存泄漏
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods:{
    getQueryParams() {
      return new Promise((resolve) => {
        const params = {};
        const queryString = window.location.search.substring(1);
        const pairs = queryString.split("&");
        for (let pair of pairs) {
          const [key, value] = pair.split("=");
          params[decodeURIComponent(key)] = decodeURIComponent(value);
        }
        this.queryParams = params;
        resolve(params);
      });
    },
    setLanguage() {
      let language = this.getPreferredLanguage();
      if (language.startsWith("zh")) {
        if (language.startsWith("zh-CN")) {
          localStorage.setItem("lang", "cn");
          this.$i18n.locale = "cn";
        }
        if (language.startsWith("zh-TW")) {
          localStorage.setItem("lang", "tw");
          this.$i18n.locale = "tw";
        }
        return;
      }
      if (language.startsWith("en")) {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        return;
      }
    },
    getPreferredLanguage() {
      return navigator.language || navigator.userLanguage;
    },
  }
};
</script>

<style>
*{
    margin: 0;
    padding: 0;
}
</style>
